import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { setFocusById } from '../../../utils/donationForm';
import {
  composeValidators,
  maxCharacters,
  required,
  valueNotIncludes,
} from '../../../utils/formFieldValidators';
import { TextField, SelectField } from '../../01_atoms/FormElements';
import { DEFAULT_COUNTRY_CODE } from '../../../utils/constants';

/**
 * Renders a single field from the address form schema.
 */
const AddressSchemaField = ({
  name,
  machineFieldName,
  isRequired,
  title,
  enum: options = [],
  info = '',
}) => {
  let placeholder = title;
  let autoComplete = null;
  let requireErrorMessage = 'Required';

  // The validators for fields.
  const validators = [];

  // The handlers for custom fields.
  if (machineFieldName === 'addressLine1') {
    placeholder = 'Line 1';
    autoComplete = 'address-line1';
    requireErrorMessage = 'Please enter your address';
  }

  if (machineFieldName === 'addressLine2') {
    placeholder = 'Line 2 (optional)';
    autoComplete = 'address-line2';
  }

  if (machineFieldName === 'postalCode') {
    placeholder = 'A12';
    autoComplete = 'postal-code';
    requireErrorMessage = 'Please enter your postcode';
  }

  if (machineFieldName === 'locality') {
    placeholder = ' ';
    requireErrorMessage = 'Please add town/city for this address';
  }

  if (machineFieldName === 'administrativeArea') {
    placeholder = ' ';
    requireErrorMessage = `Please enter your ${title.toLowerCase()}`;

    validators.push(
      valueNotIncludes('select', `Please make sure the ${title.toLowerCase()} is correct`),
    );
  }

  if (isRequired) {
    validators.push(required(requireErrorMessage));
  }

  useEffect(() => {
    if (DEFAULT_COUNTRY_CODE === 'GB') {
      setFocusById('address.addressLine1');
    }
  }, []);

  // Extra wrapper class for address step styling.
  const wrapperClass =
    machineFieldName === 'administrativeArea'
      ? 'field-address-administrative-area-wrapper'
      : `field-${name.replace(/\./g, '_')}-wrapper`;

  // Prepare the options.
  if (options && options.length) {
    const selectOptions = [
      { value: '', label: ' ' },
      ...options.map((item) => ({ value: item, label: item })),
    ];

    return (
      <div className={wrapperClass}>
        <SelectField
          key={name}
          name={name}
          label={title}
          placeholder={placeholder}
          validate={composeValidators(...validators)}
          isRequired={isRequired}
          options={selectOptions}
        />
      </div>
    );
  }

  if (machineFieldName === 'administrativeArea') {
    validators.push(maxCharacters(50));
  }

  return (
    <div className={wrapperClass}>
      <TextField
        key={name}
        name={name}
        label={title}
        validate={composeValidators(...validators)}
        isRequired={isRequired}
        autoComplete={autoComplete}
        placeholder={placeholder}
        info={info}
      />
    </div>
  );
};

AddressSchemaField.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  enum: PropTypes.arrayOf(PropTypes.string),
  info: PropTypes.string,
  machineFieldName: PropTypes.string.isRequired,
};

export default AddressSchemaField;
